module.exports = __webpack_public_path__ + "img/heptagon.af45a29d.svg";